import qs from 'qs'

export const createURL = (state: Record<string, unknown>): string => {
  return `?${qs.stringify(state)}`
}

export const searchStateToUrl = (
  pathname: string,
  searchState: Record<string, unknown>
): string => {
  return searchState ? `${pathname}${createURL(searchState)}` : ''
}

export const urlToSearchState = (search: string): Record<string, unknown> => {
  return qs.parse(search.slice(1))
}
